var capitalizeString = function (input) {
    var words = input.split(' ');
    if (words.length === 1) {
        return input.substr(0, 1).toUpperCase() + input.substr(1);
    }
    return words.map(function (word) { return word[0].toUpperCase() + word.substr(1); }).join(' ');
};
export default capitalizeString;
